

import __layout_0 from '/home/vsts/work/1/s/Predict.LargeLoss.Client/src/layouts/default.vue'
export const layouts = {
'authenticated': () => import('/home/vsts/work/1/s/Predict.LargeLoss.Client/src/layouts/authenticated.vue'),
'default': __layout_0,
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      meta: route.meta,
      component: layouts[route.meta?.layout || 'default'],
      children: route.path === '/' ? [route] : [{...route, path: ''}]
    }
  })
}
